import {Role} from "./Role";
import {UserProfileResponse} from "../AppContext";
import {ResearcherStatus} from "../../researcher/model/ResearcherStatus";

/**
 * This class represents a user profile for the user currently logged in. It will contain only the relevant
 * information we need in the frontend
 */
export class UserProfile {
  userName: string = '';
  roles: Role[] = [];
  researcherStatus?: ResearcherStatus;
  hasSignedUpViaInvitation: boolean = false;

  constructor(userProfile?: UserProfileResponse) {
    if (userProfile) {
      this.userName = userProfile.userName
      this.roles = userProfile.roles;
      this.researcherStatus = userProfile.researcherStatus;
      this.hasSignedUpViaInvitation = userProfile.hasSignedUpViaInvitation;
    }
  }

  isInAnyRole(...roles: Role[]) {
    return roles.filter(r => this.roles.includes(r)).length > 0;
  }
}
